const { h, render, Component } = require('preact');
const GetawaysOrderStatusView = require('../../views/main/getaways_order_status')
const RegularOrderStatusView = require('../../views/main/regular_order_status')

class OrderStatus extends Component {
  constructor(props) {
    super(props);
  }

  getOrderStatus(){
    const order = this.props.order
    let component = <RegularOrderStatusView order={order} I18n={this.props.I18n}/>
    if (['GETAWAYS_TONIGHT', 'GETAWAYS_MARKET_RATE', 'GETAWAYS_BOOKING'].indexOf(this.props.order.DEAL_TYPE) > -1)
      component = <GetawaysOrderStatusView order={order} I18n={this.props.I18n}/>
    else if (["GOODS_VOUCHER","GOODS_SHIPPING"].indexOf(this.props.order.DEAL_TYPE) > -1 && this.props.order.STATE!='REFUNDED')
      {
      const GoodsOrderStatusContainer = require('./goods_status')
      component = <GoodsOrderStatusContainer order={order} I18n={this.props.I18n}/>
      }
    return component
  }

  render() {
    return this.getOrderStatus()
  }

}
module.exports = OrderStatus
